import { RouteRecordRaw } from "vue-router";

export const docTypeRoutes: Array<RouteRecordRaw> = [
  {
    path: "/doc-types/:id/edit",
    name: "DocTypeEdit",
    component: () => import("../views/DocTypeEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "docType",
      requiredRight: "viewUI",
    },
  },
];
